const HOSTUrl = {
    development: 'http://0.0.0.0', // 测试地址
    production: 'https://qiankun.test.acme-ai.com', // 正式地址
};

const baseUrl = {
    'http://localhost:4000': 'https://newapi.test.acme-ai.com',
    'https://qiankun.test.acme-ai.com': 'https://newapi.acme-ai.com',
};

export default {
    BASE_URL: baseUrl[window.location.origin],
    HOSTUrl: HOSTUrl[process.env.NODE_ENV],
    fileUploadSize: 100, // 普通上传文件大小限制
    defaultAvatarUrl: 'https://zijian-storage.obs.cn-north-4.myhuaweicloud.com:443/default_avatar.png', // 默认头像
};
